'use strict';

const IsotopicDistribution = require('./IsotopicDistribution');

module.exports = IsotopicDistribution;
